module.exports = __webpack_public_path__ + "img/non_thumb.4100e3b3.jpg";